import { PlatformUIManager } from "../libs/js/PlatformUIManager";
import { InpageBase } from "../libs/js/InpageBase";
import { PageObserver } from "../../../utils/PageObserver";
import { ImpressionDetector } from "../../../utils/ImpressionDetector";
import { API } from "../../../utils/api";
import {APICallMethod, PlayerType, StreamDesignLayout, event, FloatingType} from "../../../utils/const";
import {startSkipTimeout} from "../../../utils/utils";

const streamRatingDefaults = {
	like: {
		active: false,
		logged: false,
		amount: 0,
	},
	dislike: {
		active: false,
		logged: false,
	},
};

class Stream extends InpageBase {
	constructor(cfg) {
		super(cfg);
		
		this.streamConfig = cfg.streamConfig;
		this.streamUIData = { tmpl: StreamDesignLayout.EMPTY }; // default tmpl in case of some error
		this.streamRating = null;
		
		this.skipEnabled = false;
		
		this.emitter.on(event.Stream.StartSkipTimer, () => {
			this.skipEnabled = false;
			this.uiManager.ui.skipPreviewTimer.style.display = this.uiManager.ui.skip.style.display = 'flex';
			this.uiManager.ui.skip.classList.remove('hidden');
			
			startSkipTimeout({
				seconds: this.content.contentPlayedBefore() ? this.config.content.midroll_skip : this.config.content.preroll_skip,
				circleContent: this.uiManager.ui.skipContent,
				circleProgressBar: this.uiManager.ui.skipProgress,
				onFinish: () => {
					this.uiManager.ui.skipText.innerText = 'Пропустить'; // Продолжить
					// this.uiManager.ui.skipArrow.style.display = 'block';
					this.uiManager.ui.skipPreviewTimer.style.display = 'none';
					
					this.skipEnabled = true;
				}
			});
		});
		this.emitter.on(event.Stream.HideSkipButton, () => {
			this.uiManager.ui.skip.classList.add('hidden');
		})

		const TEMPLATE_LOADERS = {
			[StreamDesignLayout.LIGHT]: () => import('./js/lightThemeLoader'),
			[StreamDesignLayout.EMPTY]: () => import('./js/emptyThemeLoader'),
			[StreamDesignLayout.DEFAULT]: () => import('./js/defaultThemeLoader'),
		}

		const CONTENT_LOADERS = {
			[PlayerType.EMBED]: () => import('../../../content/stream/EmbedContent'),
			[PlayerType.STREAM]: () => import('../../../content/stream/StreamContent'),
		}
		
		this.getUIData().then((streamUIData) => {
			window.vadsLastID = streamUIData.id;

			this.streamUIData = {
				...this.streamUIData,
				...streamUIData
			};

			return this.fetchAndBuild(TEMPLATE_LOADERS[this.streamUIData.tmpl](), CONTENT_LOADERS[this.config.type]());
		}).catch(error => {
			console.log('streamUIData fetch error: ', error);

			return this.fetchAndBuild(TEMPLATE_LOADERS[StreamDesignLayout.EMPTY](), CONTENT_LOADERS[this.config.type]())
		});
	}

	fetchAndBuild = (template, content) => Promise.all([template, content])
		.then(([templateModule, contentModule]) => [templateModule.default, contentModule.default])
		.then(([template, Content]) => this.build(template, Content));

	build = (template, Content) => {
		this.cssVars = {
			...this._parseCSSVars(),
			...this._parseStreamCSSVars(),
		};
		this.uiManager = new PlatformUIManager({ container: this.container, template, emitter: this.emitter, config: this.config, cssVars: this.cssVars });
		this.pageObserver = new PageObserver(this.uiManager.ui.streamView);
		this.impressionDetector = new ImpressionDetector({
			container: this.uiManager.ui.player,
			pageObserver: this.pageObserver,
			options: {
				type: 'sticky',
			},
		});

		this.content = new Content({
			container: this.uiManager.ui.contentContainer,
			config: this.config,
			emitter: this.emitter,
			streamUIData: this.streamUIData,
			streamConfig: this.streamConfig,
			streamView: this.uiManager.ui.streamView,
			pageObserver: this.pageObserver,
			floatObserver: this.config.floating_mode === FloatingType.ABOVE_AFTER_START ? new PageObserver(this.uiManager.ui.player) : null,
		});

		this.insertUIDataToTemplate();
		this.beforeStart();
	}

	_parseStreamCSSVars = () => ({
		streamLogo: this.streamUIData.logo ? 'block' : 'none',
		streamLogoSource: this.streamUIData.logo || '',
		streamName: this.streamUIData.name,
		streamViews: this.formatCounter(this.streamUIData.view),
		streamLikes: this.formatCounter(this.streamUIData.like),
	});
	
	getUIData = () => fetch(this.streamConfig.streamUIDataUrl).then(result => result.json());
	
	insertUIDataToTemplate = () => { // TODO: move to template({ ... }) variables
		const { streamLikesCounter, streamLikeButton, streamDislikeButton, streamBackground, skipPreview, skip, streamView } = this.uiManager.ui;
		
		streamView.addEventListener('click', (evt) => evt.stopPropagation())
		streamBackground.addEventListener('click', () => this.emitter.emit(event.Stream.StreamBackgroundClicked));
		skip.addEventListener('click', () => {
			if (this.skipEnabled) this.emitter.emit(event.Player.AdSkipRequest);
		});
		skipPreview.style.backgroundImage = `url(${this.streamUIData.poster})`;
		
		if (this.streamUIData.tmpl === StreamDesignLayout.EMPTY) return;
		
		this.parseRatingData();
		const rating = this.streamRating[this.streamUIData.id];
		
		streamLikeButton.addEventListener('click', () => {
			if (!rating.like.emitted) {
				rating.like.emitted = true;
				API.call(this.streamConfig.streamTrackingUrls.rate.replace('(cb)', Date.now()).replace('(content.id)', this.streamUIData.id).replace('(rate)', 'like'), {}, {}, APICallMethod.IMAGE);
			}
			
			if (rating.like.active) {
				rating.like.amount -= 1;
				streamLikeButton.classList.remove('vads-rate-active');
			} else {
				streamLikeButton.classList.add('vads-rate-active');
				rating.like.amount += 1;
				
				if (rating.dislike.active) {
					streamDislikeButton.classList.remove('vads-rate-active');
					rating.dislike.active = false;
				}
			}
			
			rating.like.active = !rating.like.active;
			streamLikesCounter.innerText = this.formatCounter(rating.like.amount);

			try {
				localStorage.setItem('vads-stream-rating', JSON.stringify(this.streamRating));
			} catch(e) {}
		});
		
		streamDislikeButton.addEventListener('click', () => { // TODO: вынести в общую функцию
			if (!rating.dislike.emitted) {
				streamDislikeButton.emitted = true;
				API.call(this.streamConfig.streamTrackingUrls.rate.replace('(cb)', Date.now()).replace('(content.id)', this.streamUIData.id).replace('(rate)', 'dis'), {}, {}, APICallMethod.IMAGE);
			}
			
			if (rating.dislike.active) {
				streamDislikeButton.classList.remove('vads-rate-active');
			} else {
				streamDislikeButton.classList.add('vads-rate-active');
				
				if (rating.like.active) {
					rating.like.amount -= 1;
					streamLikesCounter.innerText = this.formatCounter(rating.like.amount);
					streamLikeButton.classList.remove('vads-rate-active');
					rating.like.active = false;
				}
			}
			
			rating.dislike.active = !rating.dislike.active;
			try {
				localStorage.setItem('vads-stream-rating', JSON.stringify(this.streamRating));
			} catch(e) {}
		});
	}
	
	parseRatingData = () => {
		const { streamLikeButton, streamDislikeButton, streamLikesCounter } = this.uiManager.ui;

		try {
			this.streamRating = JSON.parse(localStorage.getItem('vads-stream-rating')) || {};
		} catch(e) {
			this.streamRating = {};
		}

		if (!this.streamRating[this.streamUIData.id]) {
			this.streamRating[this.streamUIData.id] = { ...streamRatingDefaults };
		}
		
		const rating = this.streamRating[this.streamUIData.id];
		if (rating.like.amount < this.streamUIData.like) {
			rating.like.amount = this.streamUIData.like;
			rating.like.emitted = false;
			rating.like.active = false;
			
			rating.dislike.emitted = false;
			rating.dislike.active = false;
		} else if (rating.like.active) {
			streamLikeButton.classList.add('vads-rate-active');
			streamLikesCounter.innerText = this.formatCounter(rating.like.amount);
		} else if (rating.dislike.active) {
			streamDislikeButton.classList.add('vads-rate-active');
		}
	}
	
	formatCounter = (number) => {
		if (number < 1000) return number;
		if (number < 100_000) return `${(number / 1000).toFixed(1)} тыс.`;
		
		return `${Math.round(number / 1000)} тыс.`;
	}
}

export { Stream as Player };
